import { useEffect } from 'react';

const useWindowScroll = (x, y) => useEffect(() => void window.scrollTo(x, y), [x, y]);

export default useWindowScroll;
